var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.gridConfiguration
    ? _c(
        _setup.LfGridComponent,
        _vm._b(
          {
            ref: "mainGrid",
            attrs: { gridConfiguration: _setup.gridConfiguration },
            on: {
              rowClick: _setup.onRowClick,
              contextMenuClicked: _setup.onContextMenuClicked,
              toolbarClicked: _setup.onToolbarClicked,
              rowsSelected: _setup.onRowsSelected,
              contextMenuBeforeOpen: _setup.onContextMenuBeforeOpen,
              dataStateChange: _setup.onDataStateChange,
            },
          },
          "LfGridComponent",
          _setup.props,
          false
        )
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }